import { classNames } from '@progress/kendo-react-common';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { CurrencyValue, FlexGrid, FlexGridItemProps, FlexGridLabel, FlexGridProps, FlexGridValue, Icon, Tooltip } from 'components';
import styles from './PanelGrid.module.scss';

export const PanelGrid = ({ children, className }: FlexGridProps) => (
    <FlexGrid className={classNames(styles.grid, className)}>{children}</FlexGrid>
);

export type PanelGridItemProps = {
    tooltip?: string
} & FlexGridItemProps;

export type PanelGridAmountProps = {
    value: number
} & PanelGridItemProps;

export const PanelGridAmount = ({ value, valueClassName, ...rest }: PanelGridAmountProps) => (
    <PanelGridItem
        {...rest}
        value={<CurrencyValue value={value} />}
        valueClassName={classNames(styles.amount, valueClassName)}
    />
);

export const PanelGridItem = ({ label, labelClassName, value, valueClassName, tooltip }: PanelGridItemProps) => {
    return (
        <div className={styles.detailsContainer}>
            <FlexGridLabel className={classNames(styles.label, labelClassName)}>
                <span>{label}</span>
                {tooltip && (
                    <Icon
                        className={styles.icon}
                        icon={faInfoCircle}
                        title={tooltip}
                    />
                )}
            </FlexGridLabel>
            <FlexGridValue className={classNames(styles.value, valueClassName)}>
                {value}
            </FlexGridValue>
        </div>
    );
};